import * as angular from "angular";
import {IController} from "angular";
import {TravelTimeRuleModel} from "../../models/travel-time-rule.model";
import * as _ from "lodash";

export class TravelTimeRuleTable implements IController {

  rule: TravelTimeRuleModel;
  onEdit: Function;
  onUpdate: Function;
  onDelete: Function;

  public travelTimeFactorPercent: number;
  public ruleCopy?: TravelTimeRuleModel;

  /* @ngInject */
  constructor() {

  }

  $onInit() {

  }

  $onChanges(changes) {
    if (changes.rule) {
      this.ruleCopy = undefined;
      this.travelTimeFactorPercent = this.rule?.travelTimeFactor ? _.round(this.rule.travelTimeFactor * 100, 2) : undefined;
    }
  };

  onQuickEditChange(isEnabled) {
    this.ruleCopy = isEnabled ? angular.copy(this.rule) : undefined;
  }

  onTravelTimeFactorChange(travelTimeFactorPercent) {
    this.ruleCopy.travelTimeFactor = _.round(travelTimeFactorPercent/100, 2);
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .component('travelTimeRuleTable', {
    bindings: {
      rule: '<',
      onEdit: '&?',
      onUpdate: '&?',
      onDelete: '&?'
    },
    template: require('./travel-time-rule-table.html').default,
    controller: TravelTimeRuleTable
  });
